interface ActionTypes {
    CHANGE_LANG: string
};

export const actionTypes: ActionTypes = {
    CHANGE_LANG: 'CHANGE_LANG'
};